module.exports = __webpack_public_path__ + "img/splicing_prograss_three_sss.1fa84160.png";